module.exports = __webpack_public_path__ + "img/1f56953.jpg";